export function convertToFourPointScale(percent) {
    const p = parseFloat(percent);
    if (isNaN(p)) return 0;
  
    if (p >= 97) return 4.0;
    if (p >= 93) return 4.0;
    if (p >= 90) return 3.7;
    if (p >= 87) return 3.3;
    if (p >= 83) return 3.0;
    if (p >= 80) return 2.7;
    if (p >= 77) return 2.3;
    if (p >= 73) return 2.0;
    if (p >= 70) return 1.7;
    if (p >= 67) return 1.3;
    if (p >= 65) return 1.0;
    return 0.0;
  }
  